import Request from "service/request";

const request = new Request();

export class landingPageService {
  static statistics = async (data: { limit: number; offset: number }) => {
    const query = `?limit=${data.limit}&offset=${data.offset}`;
    return await request.get("admin/log/landing" + query).then((res) => res.data);
  };
  static statistics2 = async (data: {
    limit: number;
    offset: number;
    type: string;
    startDate: string;
    endDate: string;
  }) => {
    const query = `?limit=${data.limit}&offset=${data.offset}&type=${data.type}&startDate=${data.startDate}&endDate=${data.endDate}`;
    return await request.get("admin/log/landing/pricePension" + query).then((res) => res.data);
  };
  static getMemberList = async () => {
    const result = await request.get(`admin/member/landing/list?limit=10&offset=0`);
    return result.data;
  };
}
